module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":".gatsby","tsNode":{"project":"tsconfig.build.json"}},
    }]
